;(function($, undefined){

    function loadSWF() {
        var $el, data, swfUrl, id, width, height,
            version, expressInstallSwfurl, flashvars,
            params, attributes, callbackFn;

        $el = $(this);
        data = $el.data('swfobject');
        swfUrl = data.swfUrl;
        id = $el.attr('id');
        width = data.width;
        height = data.height;
        version = data.version || '9.0.0';
        expressInstallSwfurl = data.expressInstallSwfurl;
        flashvars = data.flashvars || {};
        params = {wmode: 'transparent'};
        _.extend(params, data.params || {});
        attributes = data.attributes || {};
        callbackFn = data.callbackFn;
        if (swfUrl && id && width && height && version) {
            window.swfobject.embedSWF(
                swfUrl, id, width, height, version,
                expressInstallSwfurl, flashvars,
                params, attributes, callbackFn
            );
        }
    }

    function initSWFObject() {
        if (window.swfobject) {
            $('[data-swfobject]').each(loadSWF);
        }
    }

    window.rnn.modules.register("swfobject", {
        init: initSWFObject
    });

})(jQuery);
